(function() {
    "use strict";

    const ko = require('knockout');
    const $ = require('jquery');

    class CharacterViewModel {
        constructor(data) {
            this.id = data.id;
            this.owner = data.owner;
            this.name = ko.observable(data.name || '');
            this.avatar = ko.observable(data.avatar || null);
            this.physical = ko.observable(data.physical || '');
        }

        load() {
        }
    }

    module.exports = CharacterViewModel;
})();


// WEBPACK FOOTER //
// ./resources/scripts/viewmodels/characterViewModel.js